import types from "./actionTypes";
import { getLuaEditorData } from "./selectors";
import { dealWithLuaHandlers } from '../../undoredo/actions'

export const addLuaFiles = (payload) => ({
	type: types.ADD_LUAFILES,
	payload,
})


export const editLuaFiles = (payload) => ({
	type: types.EDIT_LUAFILES,
	payload,
})

export const deleteLuaFile = (payload) => ({
	type: types.DELETE_LUAFILES,
	payload,
})

export const onCreateLuaFiles = (payload, noUndoRedo) => (dispatch, getState) => {

	const luaCodeList = getLuaEditorData(getState());
	payload.forEach((luaCode, key) => {
		const index = luaCodeList.findIndex((i) => i.clusterlet === luaCode.clusterlet && i.event === luaCode.event && i.type === luaCode.type);
		if (index > -1) {
			if (noUndoRedo !== true) dispatch(dealWithLuaHandlers(luaCode, 'edit'))
			dispatch(editLuaFiles(luaCode));
		} else {
			if (noUndoRedo != true) dispatch(dealWithLuaHandlers(luaCode, 'add'));
			dispatch(addLuaFiles(luaCode));
		}
	})
};

export const onDeleteLuaFiles = (payload, noUndoRedo) => (dispatch, getState) => {
	payload.forEach(lua => {
		if (noUndoRedo !== true) dispatch(dealWithLuaHandlers(lua, 'delete'))
		dispatch(deleteLuaFile(lua));
	})
}

export const updateFullHandlers = (handlers) => ({
	type: types.UPDATE_FULL_HANDLERS,
	payload: handlers
})

export const resetHandlers = (handlers) => ({
	type: types.RESET_HANDLERS,
	payload: handlers
})